<section class="vh100">
    <div class="cw" fxLayout="column">

        <div fxLayoutAlign="center">
            <mat-icon class="ftxxxl gray-4 linkIcon centertext"> security</mat-icon>
        </div>

        <h6 class="h6Title centertext">Política de Cookies </h6>
        <h6 class="h6Title"> 1. ¿Qué son las cookies? </h6>
        <p>Las cookies son pequeños archivos planos guardados por su navegador mientras navega por los sitios web. Se
            pueden usar para almacenar, recopilar y almacenar datos sobre sus actividades en los sitios web, incluso en
            PREDYC. Las cookies también nos permiten recordar cosas sobre sus visitas a PREDYC, y hacer que el sitio sea
            más fácil de usar.
            Utilizamos cookies de sesión, que caducan después de un tiempo determinado, estas cookies permanecen
            almacenadas en su navegador. Utilizamos cookies de sesión para identificarlo durante una sola sesión de
            navegación, como cuando inicia sesión en PREDYC.
        </p>
        <h6 class="h6Title "> 2. ¿Por qué PREDYC usa cookies? </h6>
        <p>
            Usamos cookies y tecnologías similares, para entregar, medir y mejorar nuestros servicios y experiencia de
            usuario de varias maneras. Utilizamos estas cookies cuando visita nuestro sitio web a través de un
            navegador. A medida que adoptamos tecnologías adicionales, también podemos recopilar datos adicionales a
            través de otros métodos.
            <br><br>
            Usamos cookies para los siguientes propósitos:
            <br>
            <br><span class="ft500">Autenticación y seguridad</span> <br><br>
            <li>Para iniciar sesión en PREDYC.</li>
            <br><span class="ft500">Preferencias del sitio</span> <br><br>
            <li>Para recordar datos sobre su navegador y sus preferencias del sitio. Para recordar su configuración y
                otras opciones que ha realizado durante su sesión de aprendizaje.</li>
            <br><span class="ft500">Analítica e investigación</span> <br><br>
            <li>Para ayudarnos a mejorar y comprender cómo las personas usan PREDYC.</li>
            <li>Por ejemplo, las cookies nos ayudan a probar diferentes versiones de PREDYC para ver qué características
                o
                contenido prefieren los usuarios, los webs beacons nos ayudan a determinar qué mensajes de correo
                electrónico se abren y las cookies nos ayudan a ver cómo interactúa con PREDYC, como los enlaces en los
                que
                hace clic.</li>
            <li>También trabajamos con herramientas analíticas como Google Analytics o Facebook Pixel cómo los usuarios
                usan nuestro sitio y servicios. Esos proveedores de servicios pueden recopilar esos datos ellos mismos o
                nosotros podemos divulgarlos.</li>
            <li>Puede optar por excluirse de algunos de estos servicios a través de herramientas como el complemento de
                exclusión de navegador de Google Analytics y la cookie de exclusión de Hotjar.</li>
            <br><span class="ft500">Publicidad</span> <br><br>
            <li>Para proporcionarle publicidad más relevante</li>
            <li>Para obtener más información sobre las cookies de orientación y publicidad, y sobre cómo puede optar por
                no participar, visite www.allaboutcookies.org/manage-cookies/index.html o, si se encuentra en la Unión
                Europea, visite el sitio de Your Online Choices.</li>
            <li>Tenga en cuenta que cuando la tecnología publicitaria está integrada en los Servicios, aún puede recibir
                publicidad en otros sitios web y aplicaciones, pero no se adaptará a sus intereses.</li>
        <h6 class="h6Title "> 3. ¿Cuáles son mis opciones de privacidad? </h6>

        Tiene varias opciones para controlar o limitar la forma en que nosotros y nuestros socios utilizamos las
        cookies:
        <br><br>
        <li>La mayoría de los navegadores aceptan de forma automática las cookies, pero puede cambiar la
            configuración
            de su navegador para desactivar/bloquear/rechazar las cookies, puede consultar artículos de soporte de
            su
            navegador. Si decide rechazar las cookies, tenga en cuenta que es posible que no pueda iniciar sesión,
            personalizar o utilizar algunas funciones interactivas en nuestro sitio web.</li>
        <li>Para obtener información y controlar las cookies utilizadas para publicidad personalizada de las
            empresas
            participantes, consulte las páginas de exclusión voluntaria para la Iniciativa publicitaria en red y la
            Alianza publicitaria digital, o si se encuentra en la Unión Europea, visite el sitio Su elección en
            línea.</li>
        <li>Para obtener información general sobre cómo orientar las cookies y cómo deshabilitarlas, visite
            www.allaboutcookies.org.</li>
        <h6 class="h6Title "> 4. Actualizaciones e información de contacto </h6>
            <p>
        De vez en cuando, podemos actualizar esta Política de cookies. Si lo hacemos, le notificaremos publicando la
        política en nuestro sitio con una nueva fecha de vigencia. Si hacemos algún cambio importante, tomaremos
        medidas razonables para notificarle con anticipación sobre el cambio planificado.
        Si tiene alguna pregunta sobre nuestro uso de cookies, envíenos un correo electrónico a <a
            href="mailto:contacto@predyc.com" class="blueLink" target="_blank">contacto@predyc.com</a>.
        </p>


    </div>
</section>